import { render, staticRenderFns } from "./PaymentMethodTile.vue?vue&type=template&id=30c08ef3&"
import script from "./PaymentMethodTile.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethodTile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports